/**
 * CargaTemp
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {CargaTempCollection} from '@/model/collection/CargaTempCollection'

/* TODO: review generated class */
export class CargaTemp extends Resource {
  idCargaPk: number = 0

  get $id() {
    return this.idCargaPk
  }
  set $id(val) {
    this.idCargaPk = val
  }

  /**
   * Gets a instance of a given ID of CargaTemp
   */
  async getCargaTemp(id: number) {
    return await Request.get(`/admin/carga-temp/${id}`)
      .name('getCargaTemp')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of CargaTemp
   */
  static async listCargaTemp(params: any) {
    return await Request.get(`/admin/carga-temp`, {params})
      .name('listCargaTemp')
      .as(CargaTempCollection)
      .getData()
  }

  /**
   * Persists a new instance of CargaTemp. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistCargaTemp() {
    return await Request.post(`/admin/carga-temp`, this)
      .name('persistCargaTemp')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of CargaTemp to use it in a CSV file
   */
  static async listCsvCargaTemp(params: any) {
    return await Request.get(`/admin/carga-temp/csv`, {params})
      .name('listCsvCargaTemp')
      .as(CargaTempCollection)
      .getData()
  }
}
